import React from 'react';
import {
    Box,
    Typography,
    Switch,
} from '@mui/material';
import { Group } from '@mui/icons-material';

interface TestingHeaderProps {
    compareMode: boolean;
    onCompareModeChange: (value: boolean) => void;
}

export const TestingHeader: React.FC<TestingHeaderProps> = ({
    compareMode,
    onCompareModeChange,
}) => {
    return (
        <>
            {/* Select Test Candidates Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, mt: 1 }}>
                <Group sx={{ color: 'primary.main', fontSize: 24 }} />
                <Box>
                    <Typography variant="h6" fontWeight={700} sx={{ fontSize: '1.1rem', color: '#1a1a1a' }}>
                        Select Test Candidates
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Choose 1-3 candidates to test your new prompt against.
                    </Typography>
                </Box>
            </Box>

            {/* Header with comparison toggle - Lovable style */}
            <Box sx={{
                mb: 3,
                p: 2,
                bgcolor: 'rgba(0, 0, 0, 0.02)',
                borderRadius: 1.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Box>
                    <Typography variant="body2" fontWeight={600} gutterBottom>
                        Compare with current active prompt
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Run both prompts side-by-side for comparison
                    </Typography>
                </Box>
                <Switch
                    checked={compareMode}
                    onChange={(e) => onCompareModeChange(e.target.checked)}
                    color="primary"
                />
            </Box>
        </>
    );
};
